import React from 'react';
import { isMobile } from 'common/helpers';

import Carousel from './Carousel';
import { images } from './constants';
import { FeaturedHotelSlider as S } from './styles';

const content = {
  web: {
    title: 'Official Hotel for SWC Asia 2019',
  },
  mobile: {
    title: 'Official Hotel for SWC 2019',
  },
};

class FeaturedSlider extends React.PureComponent {
  state = {
    activeIndex: 0,
  }

  changeIndex = (e) => this.setState({ activeIndex: e.page.index });

  slideTo = (index) => this.slider.to(index, 500);

  next = () => this.slider.next();

  prev = () => this.slider.prev();

  render() {
    const { activeIndex } = this.state;
    const title = (isMobile() ? content.mobile.title : content.web.title);
    return (
      <S.Wrapper>
        <section>
          <h3>{title}</h3>
          <Carousel
            onChange={this.changeIndex}
            innerRef={(ref) => { this.slider = ref; }}
          />
        </section>
        {!isMobile() ? (
          <ul>
            {images.map((image, index) => (
              <S.Thumbnail key={image.img} active={activeIndex === index}>
                <button onClick={() => this.slideTo(index)}>
                  <img src={image.thumb} alt="" />
                </button>
              </S.Thumbnail>
            ))}
          </ul>
        ) : null }
      </S.Wrapper>
    );
  }
}

export default FeaturedSlider;



// WEBPACK FOOTER //
// ./src/containers/Hotel/FeaturedSlider.js